module.exports = __webpack_public_path__ + "img/login-page.5edc0913.svg";